import { useControllableState as _useControllableState } from '@radix-ui/react-use-controllable-state';
import * as React from 'react';

type UseControllableStateParams<T> = {
  prop: T | undefined;
  defaultProp?: T | undefined;
  onChange: ((state: T) => void) | undefined;
  fallbackValue: T;
};

/**
 * Enhanced version of useControllableState that allows you to set a fallback value so it is always defined.
 * @param prop
 * @param defaultProp
 * @param onChange
 * @param fallbackValue
 */
export function useControllableState<T>({
  prop,
  defaultProp,
  onChange,
  fallbackValue
}: UseControllableStateParams<T>): readonly [
  T,
  React.Dispatch<React.SetStateAction<T>>
] {
  const [internalState, setInternalState] = _useControllableState({
    prop,
    defaultProp: defaultProp ?? fallbackValue,
    onChange
  });

  return [
    internalState !== undefined ? internalState : fallbackValue,
    setInternalState as React.Dispatch<React.SetStateAction<T>>
  ];
}
